import { useQuery } from '@tanstack/react-query';

import { ALGOLIA } from '../../../apis/constants';
import { fetchRequest, usePrepareRequest } from '../../../apis/helpers';
import { type WebServiceError } from '../../../utils/apis/WebServiceError';
import { type AlgoliaCredentials } from '../types';

export function useAlgoliaCredentialsQuery() {
  const { headers, endpoint } = usePrepareRequest({ serviceApi: ALGOLIA });

  return useQuery<AlgoliaCredentials, WebServiceError>({
    queryKey: ['algolia-credentials'],
    queryFn: () => fetchRequest<AlgoliaCredentials>({ headers, url: endpoint }),
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
